module.exports = __webpack_public_path__ + "assets/img/m-list-logo-en.cddac130.png";